<script>
  import { AlertTriangle } from '../lib/icons/index.js';
  import { friendlyError } from '../lib/labels.js';
  import { t } from '../i18n/index.js';

  // Accepts an Error, a string, or null. Renders nothing when falsy, so callers
  // can simply drop <ErrorBanner {error} /> in place of an {#if error} block.
  export let error = null;
  // Optional override for the headline (defaults to the friendly message).
  export let title = '';
  // When the error is already a localized, user-facing message (e.g. from the
  // auth store), pass raw so it is shown verbatim with no mapping or <details>.
  export let raw = false;

  $: info = error
    ? (raw
        ? { message: typeof error === 'string' ? error : (error?.message || ''), detail: '' }
        : friendlyError(error))
    : null;
</script>

{#if info}
  <div role="alert" class="alert alert-danger mb-4">
    <AlertTriangle size={18} class="alert-mark mt-0.5" aria-hidden="true" />
    <div class="min-w-0 flex-1">
      <p class="alert-title">{title || info.message}</p>
      {#if title}
        <p class="alert-message mt-1">{info.message}</p>
      {/if}
      {#if info.detail && info.detail !== info.message}
        <details class="mt-2">
          <summary class="cursor-pointer eyebrow text-danger">
            {info.detailLabel || $t('errors.technicalDetails')}
          </summary>
          <pre class="mt-1 whitespace-pre-wrap break-words text-xs text-muted">{info.detail}</pre>
        </details>
      {/if}
    </div>
  </div>
{/if}
